var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-qr-code"},[_c('div',{ref:"qrcode",style:({ padding: this.padding + 'px' }),attrs:{"id":"qrcode"}},[_vm._v(_vm._s(_vm.$t("service.loading-in")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }